import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "@/constants/contact";

const AssessmentFailedPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 py-6 max-w-lg">
        <Card>
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <div className="rounded-full bg-red-100 p-3">
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
            </div>
            <CardTitle className="text-xl font-bold text-jungle">
              Assessment Not Passed
            </CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="bg-red-50 p-4 rounded-lg border border-red-200">
              <p className="text-red-800 font-medium mb-2">
                You did not meet the required score for this assessment
              </p>
              <p className="text-red-700 text-sm">
                Unfortunately, you did not achieve the minimum score required to
                proceed to the next stage of the application process at this
                time.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium text-gray-900">What happens next?</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-red-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  You can reapply and retake the assessment in 30 days
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-red-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  Review our driver requirements before reapplying
                </li>
                <li className="flex items-start">
                  <span className="inline-block w-2 h-2 bg-red-500 rounded-full mt-1.5 mr-3 flex-shrink-0"></span>
                  Consider the scenarios presented in the assessment and how you
                  might approach them differently
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-600">
                If you have questions about your assessment or application,
                please contact us at{" "}
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  className="text-honeycomb hover:underline"
                >
                  {SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </CardContent>

          <div className="p-6 pt-0 space-y-3">
            <Link to="/application-status" className="w-full block">
              <Button variant="outline" className="w-full">
                Check Application Status
              </Button>
            </Link>
            <Link to="/" className="w-full block">
              <Button className="w-full bg-honeycomb hover:bg-amber-500">
                <Home className="mr-2 h-4 w-4" /> Return to Home
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </AppLayout>
  );
};

export default AssessmentFailedPage;
